/* eslint-disable react-hooks/exhaustive-deps */

import { Button, Layout } from 'antd';
import React from 'react';
import transaction from 'resources/img/icons/transaksi-sukses.png';
import History from 'helpers/History';
const onClick = () => {
   History.replace(`/mutasi-poin?isBack=true`);
};
const TransactionSuccess = () => {
   return (
      <>
         <Layout header="product">
            <div className="p-4 w-full max-w-[500px]">
               <div
                  className="cursor-pointer"
                  onClick={() => History.replace(`/?tabActive=2&isBack=true`)}
               >
                  <svg
                     width="17"
                     height="16"
                     viewBox="0 0 17 16"
                     fill="none"
                     xmlns="http://www.w3.org/2000/svg"
                  >
                     <path
                        d="M1.5 15L15.5 1M1.5 1L15.5 15"
                        stroke="#626B79"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                     />
                  </svg>
               </div>
               <div className="px-14 mt-[15vh]">
                  <img
                     src={transaction}
                     alt="transaction"
                     className="w-[280px] mx-auto"
                  />
                  <p className="text-lg font-semibold text-[#232933] text-center">
                     Transaksi Berhasil
                  </p>
                  <p className="text-sm font-normal text-[#232933] text-center">
                     Terima kasih telah melakukan transaksi dengan BOS.
                  </p>
               </div>
            </div>
            <div className="p-4 bg-white bottom-0 fixed w-full max-w-[500px]">
               <Button
                  size="large"
                  className="w-full text-base font-semibold text-white bg-[#D3142C] rounded-lg"
                  // disabled={tagihan.length > 9 ? false : true}
                  onClick={onClick}
                  // loading={true}
               >
                  Lihat Mutasi
               </Button>
            </div>
         </Layout>
      </>
   );
};

export default TransactionSuccess;
